import * as StoreUtil from '../util/InClientStoreUtil';
import createFetchOptions from 'owa-service/lib/createFetchOptions';
import ExtensibilityContext from 'owa-service/lib/contract/ExtensibilityContext';
import { getExtensibilityContext } from 'owa-addins-store';
import { getUserCulture } from 'owa-session-store';
import RequestOptions from 'owa-service/lib/RequestOptions';
import 'owa-addins-osfruntime';

var conversationId;
var InClientLink;

export function getConversationId(): string {
    return conversationId;
}

export function buildInClientStoreUrl(): string {
    if (typeof conversationId === 'undefined') {
        conversationId = 'Store' + OSF.OUtil.generateConversationId();
    }
    const context = getExtensibilityContext() as ExtensibilityContext;

    const UrlAdder = conversationId + '|' + window.location.href.split('?')[0];
    let storeUrl = OSF.OUtil.addXdmInfoAsHash(context.InClientStoreUrl, UrlAdder); // https://store.office.com/gyro/client
    const StoreClientParam = 'WAC_Outlook';
    storeUrl = StoreUtil.addUrlParameter(storeUrl, 'client', StoreClientParam);
    const timeStamp = Date.now();

    /*We are hardcoding this value for now since OMEX does not understand the new versioning system */
    storeUrl = StoreUtil.addUrlParameter(storeUrl, 'cv', '16.2130.0.9999');

    storeUrl = StoreUtil.addUrlParameter(storeUrl, 'ui', getUserCulture());
    storeUrl = StoreUtil.addUrlParameter(storeUrl, 'rs', getUserCulture());
    storeUrl = StoreUtil.addUrlParameter(storeUrl, 'timestamp', timeStamp.toString());
    storeUrl = StoreUtil.addUrlParameter(storeUrl, 'ep', getEntryPointCode());
    storeUrl = StoreUtil.addUrlParameter(storeUrl, 'exchver', StoreUtil.getExchangeVersion());
    storeUrl = StoreUtil.addUrlParameter(
        storeUrl,
        'privateenabled',
        context.CustomExtensionsEnabled.toString()
    );
    storeUrl = StoreUtil.addUrlParameter(storeUrl, 'cb', StoreUtil.getExtensibilityFlightInfo());
    storeUrl = StoreUtil.addUrlParameter(storeUrl, 'ClientSessionId', StoreUtil.getOwaGuid());
    storeUrl = StoreUtil.addUrlParameter(storeUrl, 'userPuid', '0');
    storeUrl = StoreUtil.addUrlParameter(
        storeUrl,
        'gates',
        'Marketplace.Outlook.Pin.Addin.Options,Marketplace.Outlook.Pin.Addin.Calendar.Options'
    );
    return storeUrl;
}

export function createServiceEndPoint(): OSF.ServiceEndpoint {
    const clientId = OSF.OUtil.getUniqueId();
    const serviceEndPoint: OSF.ServiceEndpoint = Microsoft.Office.Common.XdmCommunicationManager.createServiceEndPoint(
        clientId
    );
    return serviceEndPoint;
}

export async function createOverrideOptions(): Promise<RequestOptions> {
    const fetchOptions = await createFetchOptions();

    fetchOptions.headers.append('X-EWS-TargetVersion', '2.80');

    /* Credentials override is not allowed */
    delete fetchOptions.credentials;
    return fetchOptions;
}

export function parseConsentStateInfo(consentState: any): string {
    let consentStateStrings = ['notresponded', 'notconsented', 'consented'];

    if (typeof consentState === 'string') {
        return consentState;
    } else {
        return consentStateStrings[consentState];
    }
}

export function getEntryPointCode(): string {
    if (InClientLink) {
        return 'il';
    }
    return 'ma';
}
export let setInClientLink = (inclientlink: boolean) => {
    InClientLink = inclientlink;
};
